import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgMyHome = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M21.074 9.335h.001c.426.331.675.84.675 1.378v10.79a.746.746 0 0 1-.75.747H3a.75.75 0 0 1-.75-.747V10.712a1.74 1.74 0 0 1 .674-1.377l8-6.216h.001a1.75 1.75 0 0 1 2.15 0zM9.544 1.342l-8 6.216A4 4 0 0 0 0 10.713v10.79A2.996 2.996 0 0 0 3 24.5h18a3 3 0 0 0 3-2.997v-10.79c0-1.234-.57-2.398-1.545-3.155l-8-6.216a4 4 0 0 0-4.91 0m8.13 15.554a1.125 1.125 0 1 0-1.317-1.824c-1.157.836-2.726 1.286-4.347 1.286-1.62 0-3.189-.45-4.344-1.285a1.125 1.125 0 0 0-1.319 1.823c1.607 1.162 3.66 1.712 5.663 1.712 2.002 0 4.056-.55 5.664-1.712"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgMyHome);
export default Memo;
